import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Checkbox — Radix's, wrapped with its label.
 *
 * The label is a required prop and is rendered as a real `<label for>`, so the box and its text are
 * one target: clicking the words toggles the box, which matters most on the kiosk's touch screen
 * and on a phone. An indeterminate checkbox reports `aria-checked="mixed"` through Radix.
 */
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { useId } from 'react';
import { cx } from '../lib/cx.js';
import { CheckIcon, DashIcon } from './icons.js';
export function Checkbox({ label, id, className, 'aria-describedby': describedBy, 'aria-invalid': invalid, ...rest }) {
    const generated = useId();
    const controlId = id ?? generated;
    return (_jsxs("div", { className: cx('clav-choice', className), children: [_jsx(RadixCheckbox.Root, { ...rest, id: controlId, className: "clav-checkbox", "aria-describedby": describedBy, "aria-invalid": invalid, children: _jsx(RadixCheckbox.Indicator, { children: rest.checked === 'indeterminate' ? _jsx(DashIcon, {}) : _jsx(CheckIcon, {}) }) }), _jsx("label", { className: "clav-choice__label", htmlFor: controlId, children: label })] }));
}
//# sourceMappingURL=checkbox.js.map